var isRTL = ($('html').attr('dir') == "rtl") ? true : false,
    winWidth = $(window).width(),
    winHeight = $(window).height(),
    lastScrollTop = 0,
    bannerPrev = '<a class="slick-prev slick-arrow" aria-label="Previous"><img src="' + customVariables.baseURL + 'img/icons/ic-left-arrow.svg" alt="" class="icon js-tosvg"></a>',
    bannerNext = '<a class="slick-next slick-arrow" aria-label="Next"><img src="' + customVariables.baseURL + 'img/icons/ic-right-arrow.svg" alt="" class="icon js-tosvg"></a>',
    bannerPrev1 = '<a class="slick-prev slick-arrow" aria-label="Previous"><img src="' + customVariables.baseURL + 'img/icons/ic-left-chevron.svg" alt="" class="icon js-tosvg"></a>',
    bannerNext1 = '<a class="slick-next slick-arrow" aria-label="Next"><img src="' + customVariables.baseURL + 'img/icons/ic-right-chevron.svg" alt="" class="icon js-tosvg"></a>',
    bodyWrapper = $('.atc-wrapper'),
    headerHeight = $('.header-wrapper').outerHeight(),
    valueUp = true,
    scrollAddValue = 0,
    addValue = 1 + scrollAddValue,
    subtractValue = -1 - scrollAddValue,
    userHasScrolled = false,
    markers = [],
    mainMap;

cssCalculation();

$('html').addClass('ready-js');

$(function () {
    browserDetect();
    addClassIOS();
    initSelect2('.js-select');
    initStoryCaro('.js-storyCaroContent', '.sec-sstories');
    initSimpleCaro('.js-instafeedCaro', '.sec-followus', '1');
    initSimpleCaro('.js-simple-slider', '.sec-practices', '1');
    initSimpleCaro('.js-sectors-slider', '.sec-sectors', '1');
    initSimpleCaro('.js-relatedCaro', '.sec-related-insights', '0');
    initSimpleCaro('.js-law-slider', '.sec-law-update', '1');
    initSimpleCaro('.js-sec-latest-news-thinking', '.sec-latest-news-thinking', '1');
    initMobSlider();
    twfeedsslider('.js-twfeedsslider', '.twitter-row');
    initFilterPopup();
    initVideo();
    initPopup();
    initVideoTabs();
    initTabs();
    initTabCategory();
    acordian();
    createTags();
    btnReadMore();
    scrollSecInit();
    showFirstTab();
    menuhover();
    $('html').addClass('ready-dom');
});

$(window).on('load', function () {
    cssCalculation();
    ChangeToSvg(); //class="js-tosvg"
    headerFixed();
    fieldFocus();
    initMobSlider();
    bannerSlider();
    dataTrim();
    initIsotop('.js-isotop');
    initIsotop('.js-isotop1');
    counter();
    getWidthVal('.js-getWidth');
    $('html').addClass('ready-page');
    setTimeout(function(){
        $('html').addClass('ready-page-post');
    }, 350);
    // initMap();
});

$(window).on('resize orientationchange', function () {
    winWidth = $(window).width();
    winHeight = $(window).height();
    headerFixed();
    initMobSlider();
    cssCalculation();
    getWidthVal('.js-getWidth', true);
});

$(window).on('scroll', function () {
    headerFixed();
    counter();
});

$(document).keyup(function (e) {
    if (e.keyCode == 27) {
        $('.js-fs-mega-menu').fadeOut();
        $('.js-fs-mega-menu').removeClass('mega-menu-active');
        $('html, body').removeClass('modal-open');
        $('#region').removeClass('active');
        $('#region-tab').removeClass('active');
        closePopup();
    }
});

function headerFixed() {
    var scroll = $(window).scrollTop();
    var shiftPoint = headerHeight;

    if ($('.js-banner-paralax').get(0)) {
        bannerParalax = $('.js-banner-paralax').height();
        shiftPoint = bannerParalax - headerHeight;
    }
    if (scroll < shiftPoint) {
        $(bodyWrapper).removeClass("header-fixed");
    } else {
        $(bodyWrapper).addClass("header-fixed");
    }
    if (!$('.temp-banner-page').length) {
        $('header').css('height', headerHeight);
    }
}

function fieldFocus() {
    $('.js-focus').focus(function () {
        $(this).parent().addClass("is-focused");

    }).blur(function () {
        $(this).parent().removeClass("is-focused");
    })
}

function browserDetect() {
    navigator.sayswho = (function () {
        var ua = navigator.userAgent,
            tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) return tem.slice(1).join('').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    })();
    $('body').addClass(navigator.sayswho);
}

function addClassIOS() {
    if (navigator.appVersion.indexOf('iPhone') >= 0 || navigator.appVersion.indexOf('iPad') >= 0) {
        $('body').addClass('browserIos');
    } else {
        $('body').removeClass('browserIos');
    }
}

function dataTrim() {
    var ellipsis = "...";
    $('[data-trim]').each(function () {
        var text = $(this).html();
        var charLimit = parseInt($(this).attr('data-trim'));
        $(this).html(TrimLength(text, charLimit));
        $(this).addClass('is--trimmed');
    });

    function TrimLength(text, maxLength) {
        text = $.trim(text);
        if (text.length > maxLength) {
            text = text.substring(0, maxLength - ellipsis.length);
            return text.substring(0, text.lastIndexOf(" ")) + ellipsis;
        } else return text;
    }
}

function ChangeToSvg() {
    $('img.js-tosvg').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');
        $.get(imgURL, function (data) {
            var $svg = $(data).find('svg');
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' insvg');
            }
            $svg = $svg.removeAttr('xmlns:a');
            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }
            $img.replaceWith($svg);
        }, 'xml');
    });
}

function initSelect2(target, search) {
    var target = $(target);
    target.each(function (i, e) {
        var tarPar = $(e).parent('.select2-box');
        var tarPlace = $(e).data('placeholder');
        var dataClass = $(e).data('class');
        $(e).select2({
            dir: isRTL,
            width: '100%',
            theme: dataClass,
            placeholder: tarPlace,
            dropdownParent: tarPar,
            minimumResultsForSearch: search,
        }).on('select2:open', function (e) {
            $('.select2-search__field').attr('placeholder', 'Search');
            $('.select2-results__options').scrollbar().parent().addClass('scrollbar-inner');
        });

    });
}

function showFirstTab() {
    $('.js-fs-mega-menu .tab-content .tab-pane:first-child').tab('show');
}
$('.js-fs-mega-menu #menu-tabs .has-child').on('click', function (e) {
    e.preventDefault();
    $('#menu-tabs a').removeClass('active');
    $(this).tab('show');
    $('.tab-content .tab-pane').removeClass('active');
    $('.tab-content .tab-pane').removeClass('show');
    $("#"+$(this).attr('data-link')).addClass('active');
    $("#"+$(this).attr('data-link')).addClass('show');

});
if (winWidth >= 768) {
    $('.js-toggle-menu').on('click', function (e) {
        e.preventDefault();
        $('html, body').toggleClass('modal-open')
        $('.js-fs-mega-menu').fadeToggle(300);
        $('.js-fs-mega-menu').toggleClass('mega-menu-active');
    });
} else {
    $('.js-fs-mega-menu-mobile .js-nav-link').on('click', function (e) {
        e.preventDefault();
        var targetMenu = $(this).attr('data-link');
        $('.js-nav-slides').hide();
        $('.js-fs-mega-menu-mobile').find('[data-slide=' + targetMenu + ']').show();
    });
    $('.js-toggle-menu').on('click', function (e) {
        e.preventDefault();
        if ($('.js-search-toggle-mob').hasClass('search-open')) {
            $('.js-fs-search-box').hide();
            $('html, body').removeClass('modal-open');
            bodyWrapper.removeClass('showing-search');
            $('.js-search-toggle-mob').removeClass('search-open');
        }
        if ($(this).hasClass('menu-open')) {
            $('html, body').removeClass('modal-open');
            $('.toggle-search').show();
            bodyWrapper.removeClass('showing-menu');
            $('.js-fs-mega-menu-mobile').fadeOut(300);
            $(this).removeClass('menu-open');
            $('.js-nav-slides').hide();
            $('.js-fs-mega-menu-mobile').find('[data-slide="master"]').show();

        } else {
            $('html, body').addClass('modal-open');
            $('.toggle-search').hide();
            bodyWrapper.addClass('showing-menu');
            $('.js-fs-mega-menu-mobile').fadeIn(300);
            $(this).addClass('menu-open');
        }

    });
    $('.js-search-toggle-mob').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('search-open')) {
            $('html, body').removeClass('modal-open');
            bodyWrapper.removeClass('showing-search');
            $('.js-fs-search-box').fadeOut(300);
            $(this).removeClass('search-open');
        } else {
            $('html, body').addClass('modal-open');
            bodyWrapper.addClass('showing-search');
            $('.js-fs-search-box').fadeIn(300);
            $('.search-field').focus();
            $(this).addClass('search-open');
        }
    });
    $('.js-cancel-search').on('click', function (e) {
        e.preventDefault();
        $('html, body').removeClass('modal-open');
        bodyWrapper.removeClass('showing-search');
        $('.js-fs-search-box').fadeOut(300);
        $(this).removeClass('search-open');
    });
    
}

$('.js-vScroll').mCustomScrollbar();
if (winWidth > 1024) {
    $('.js-vScroll-mob').mCustomScrollbar();
}

function initStoryCaro(target, parent) {
    if ($(target).length > 0) {
        $(target).each(function () {
            var $target = $(this);
            var sliderArrows = $target.parents(parent).find('.js-carousel-arrow');
            var sliderDots = $target.parents(parent).find('.js-carousel-dots');
            $target.not('.slick-initialized').slick({
                cssEase: 'linear',
                dots: false,
                rtl: isRTL,
                appendDots: sliderDots,
                arrows: true,
                infinite: true,
                speed: 400,
                autoplaySpeed: 8000,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
                draggable: true,
                appendArrows: sliderArrows,
                prevArrow: bannerPrev,
                nextArrow: bannerNext,
                asNavFor: '.js-storyCaroThumb',
                autoplay: true,
            });
        });

        $('.js-storyCaroThumb').not('.slick-initialized').slick({
            fade: true,
            dots: false,
            arrows: false,
            infinite: true,
            rtl: isRTL,
            speed: 400,
            autoplaySpeed: 8000,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            draggable: true,
            asNavFor: target,
            autoplay: true,
        });
        ChangeToSvg();
    }
}

function initSimpleCaro(target, parent, btnstyle) {
    var bannerBtnPrev;
    var bannerBtnNext;
    if (btnstyle === '1') {
        bannerBtnPrev = bannerPrev1;
        bannerBtnNext = bannerNext1;
    } else {
        bannerBtnPrev = bannerPrev;
        bannerBtnNext = bannerNext;
    }
    if ($(target).length > 0) {
        $(target).each(function () {
            var $target = $(this);
            var sliderArrows = $target.parents(parent).find('.js-carousel-arrow');
            var sliderDots = $target.parents(parent).find('.js-carousel-dots');
            var itemDesktop = $target.data('item-desktop');
            var itemMiniDesktop = $target.data('item-mindesktop');
            var itemIpadPro = $target.data('item-ipad-pro');
            var itemTablet = $target.data('item-tablet');
            var itemMobile = $target.data('item-mobile');
            $target.not('.slick-initialized').slick({
                cssEase: 'linear',
                dots: true,
                appendDots: sliderDots,
                arrows: true,
                infinite: true,
                speed: 400,
                autoplaySpeed: 8000,
                autoplay: true,
                slidesToShow: itemDesktop,
                slidesToScroll: 1,
                swipeToSlide: true,
                draggable: true,
                rtl: isRTL,
                appendArrows: sliderArrows,
                prevArrow: bannerBtnPrev,
                nextArrow: bannerBtnNext,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: itemMiniDesktop,
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: itemIpadPro,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: itemTablet,
                    }
                }, {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: itemMobile,
                    }
                }],
            });
        });
    }
}

function initMobSlider() {
    if (winWidth < 992) {
        if ($('.js-mob-slider').length > 0) {
            $('.js-mob-slider').each(function () {
                $(this).not('.slick-initialized').slick({
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 400,
                    autoplaySpeed: 8000,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    variableWidth: false,
                    centerMode: false,
                    swipeToSlide: true,
                    rtl: isRTL,
                    prevArrow: bannerPrev1,
                    nextArrow: bannerNext1,
                    appendArrows: $(this).parent('.sec-padded-bot').find('.js-arrows'),
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    }, {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        }
                    }],
                });
            });
        }
        if ($('.js-training-slider').length > 0) {
            $('.js-training-slider').each(function () {
                $(this).not('.slick-initialized').slick({
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 400,
                    autoplaySpeed: 8000,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    variableWidth: false,
                    centerMode: false,
                    swipeToSlide: true,
                    rtl: isRTL,
                    prevArrow: bannerPrev1,
                    nextArrow: bannerNext1,
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    }, {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        }
                    }],
                });
            });
        }
        $('.js-latest-news-slider').each(function () {
            var $target = $(this);
            $target.not('.slick-initialized').slick({
                dots: true,
                arrows: false,
                infinite: false,
                speed: 400,
                autoplaySpeed: 8000,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                mobileFirst: true,
                rtl: isRTL,
                responsive: [{
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2
                    }
                }]
            });
        });
        if ($('.js-training-mbslider').length > 0) {
            $('.js-training-mbslider').each(function () {
                $(this).not('.slick-initialized').slick({
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 400,
                    autoplaySpeed: 8000,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    centerMode: false,
                    swipeToSlide: true,
                    adaptiveHeight: true,
                    rtl: isRTL,
                    prevArrow: bannerPrev1,
                    nextArrow: bannerNext1,
                });
            });
        }
    } else {
        $('.js-mob-slider.slick-initialized').each(function () {
            $(this).slick('unslick');
        });
        $('.js-latest-news-slider.slick-initialized').slick('unslick');
    }
    if (winWidth < 1200) {
        $('.js-verticle-thumb-wrapper').each(function () {
            var $target = $(this);
            $target.not('.slick-initialized').slick({
                dots: true,
                arrows: true,
                infinite: true,
                speed: 400,
                autoplaySpeed: 8000,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                mobileFirst: true,
                rtl: isRTL,
                prevArrow: bannerPrev1,
                nextArrow: bannerNext1,
                responsive: [{
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            });
        });
    }
    $('.js-csr-box-slider').each(function () {
        var $target = $(this);
        $target.not('.slick-initialized').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 400,
            autoplaySpeed: 8000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            mobileFirst: true,
            rtl: isRTL,
            prevArrow: bannerPrev1,
            nextArrow: bannerNext1,
            responsive: [{
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
    });

    ChangeToSvg();
}

function bannerSlider() {
    $('.banner').addClass('is-ready');
    var bgSlider = $('.js-bg-slider');
    var bgArtSlider = $('.js-bg-artslider');
    var contentSlider = $('.js-content-slider');

    bgSlider.slick({
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        draggable: true,
        autoplay: true,
        speed: 400,
        autoplaySpeed: 10000,
        arrows: false,
        asNavFor: '.js-bg-artslider, .js-content-slider',
        infinite: true,
        arrows: true,
        dots: true,
        rtl: isRTL,
        /*customPaging: function(slider, i) {              
            slide_counter = ++i;
            if(i < 10){
                slide_counter = "0"+i;
            }    
            return '<button type="button" role="tab" id="slick-slide-control3' + i + '" aria-label="' + i + ' of ' + i + '" tabindex="-1">'+slide_counter+"</button>";            
        },*/
        prevArrow: bannerPrev1,
        nextArrow: bannerNext1,
        appendArrows: '.js-arrows'
    });
    bgArtSlider.slick({
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        draggable: false,
        autoplay: true,
        speed: 400,
        autoplaySpeed: 10000,
        arrows: false,
        asNavFor: '.js-bg-slider, .js-content-slider',
        infinite: true,
        rtl: isRTL,
    });
    contentSlider.slick({
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        draggable: true,
        autoplay: true,
        speed: 400,
        autoplaySpeed: 10000,
        arrows: false,
        asNavFor: '.js-bg-slider, .js-bg-artslider',
        infinite: true,
        rtl: isRTL,
    });
    //Mena Slider
    var menabgSlider = $('.js-mena-bg-slider');
    var menabgArtSlider = $('.js-mena-artslider');
    var menatitleSlider = $('.js-title-slider');
    var menactaSlider = $('.js-cta-slider');
    menabgSlider.slick({
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        draggable: true,
        autoplay: true,
        speed: 300,
        autoplaySpeed: 10000,
        arrows: false,
        asNavFor: '.js-mena-artslider, .js-title-slider, .js-cta-slider',
        infinite: false,
        rtl: isRTL,
    });
    menabgArtSlider.slick({
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        draggable: true,
        autoplay: true,
        speed: 300,
        autoplaySpeed: 10000,
        arrows: false,
        asNavFor: '.js-mena-bg-slider, .js-title-slider, .js-cta-slider',
        infinite: false,
        rtl: isRTL,
    });
    menatitleSlider.slick({
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        draggable: true,
        autoplay: true,
        speed: 300,
        autoplaySpeed: 10000,
        arrows: false,
        asNavFor: '.js-mena-bg-slider, .js-mena-artslider, .js-cta-slider',
        infinite: false,
        variableWidth: true,
        centerMode: true,
        dots: true,
        rtl: isRTL,
        appendDots: '.js-slickIndicator',
        customPaging: function (slider, i) {
            var currentSlideLabel = "0";
            var totalSlidesLabel = "0";
            if (i > 8) {
                currentSlideLabel = "";
            }
            if (slider.slideCount > 9) {
                totalSlidesLabel = "";
            }
            return currentSlideLabel + (i + 1) + '/' + totalSlidesLabel + slider.slideCount;
        },
    })
    menactaSlider.slick({
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        draggable: true,
        autoplay: true,
        speed: 300,
        autoplaySpeed: 10000,
        arrows: false,
        asNavFor: '.js-mena-artslider, .js-title-slider, .js-mena-bg-slider',
        infinite: false,
        rtl: isRTL,
    });
    ChangeToSvg();
}

function twfeedsslider(target, parent) {
    if ($(target).length > 0) {
        $(target).each(function () {
            var $target = $(this);
            $target.not('.slick-initialized').slick({
                fade: true,
                dots: false,
                arrows: false,
                infinite: false,
                speed: 400,
                autoplaySpeed: 8000,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
            });
        });
    }
}


function cssCalculation() {
    var headerHeight = $('.header-wrapper').outerHeight();
    var bannerHeight = winHeight * 75 / 100;
    if (!$('.temp-banner-page').length) {
        $('.js-header').css('height', headerHeight);
    } else {
        // $('.banner-content').css('padding-top', headerHeight);
    }
    $('.js-bg-slider, .banner-bg, .banner-art, .js-mena-bg-slider, .js-bg-map').css('height', bannerHeight);
    if (winWidth < 768) {
        if ($('.temp-detail').length) {
            setTimeout(() => {
                $('.scroll-fold').css('margin-top', bannerHeight);
            }, 400);
        }
    }
}


function initFilterPopup() {
    // Open Filter
    $('.js-filter-popup:not(.js-filter-popup--binded)').click(function (e) {
        e.preventDefault();
        $('html').addClass('open-filter-popup');
    });
    $('.js-filter-popup').addClass('js-filter-popup--binded');

    // Close Filter
    $('.js-filter-popup-close:not(.js-filter-popup-close--binded)').click(function (e) {
        e.preventDefault();
        $('html').removeClass('open-filter-popup');
    });
    $('.js-filter-popup-close').addClass('js-filter-popup-close--binded');

    // Reset Filter
    $('.js-filter-popup-reset:not(.js-filter-popup-reset--binded)').click(function (e) {
        e.preventDefault();
        var searchBar = $('.sec-filters .form-group input');
        var select1 = $('.js-select');

        if (searchBar.get(0)) {
            searchBar.val('');
        }

        if (select1.get(0)) {
            select1.val(0).trigger("change");
        }
    });
    $('.js-filter-popup-reset').addClass('js-filter-popup-reset--binded');
}

function initVideo() {
    $('.js-video').each(function (i) {
        var src, poster;
        src = $(this).attr('data-d-src');
        poster = $(this).attr('data-d-poster');
        if ($(this).find('.video-txt').get(0)) {
            var videoTxt = $(this).find('.video-txt')[0].outerHTML;
            $(this).addClass('has--txt');
        }

        if (winWidth < 768) {
            if ($(this).attr('data-m-src'))
                var src = $(this).attr('data-m-src');
            var poster = $(this).attr('data-m-poster');
        }

        if ($(this).hasClass('is--youtube')) {
            $(this).html(`<video preload="none" playsinline controls id="video-${i}" class="video-js" 
            data-setup='{ "techOrder": ["youtube"], "sources": [{ "type": "video/youtube", "src": "${src}"}], "youtube": { "playsinline": 1, "showinfo": 0, "controls": 0, "autohide": 1, "rel": 0 } }'>
            </video>`);
        } else {
            $(this).html(`<video preload="none" playsinline controls class="video-js" data-setup="{'width': '100%'}" poster="${poster}">
                <source src="${src}" type="video/mp4">
                <p class="vjs-no-js">
                    To view this video please enable JavaScript, and consider upgrading to a
                    web browser that
                    <a href="https://videojs.com/html5-video-support/" target="_blank"
                        >supports HTML5 video</a
                    >
                </p>
            </video>`);
        }

        // Setup DOM
        var self = this;
        $('.video-js', this).ready(function (target) {
            $('.video-js > *', this)[0].player.ready(function () {
                $('.vjs-remaining-time:not(.shifted)', self).after($('.vjs-volume-panel', self));
                $('.vjs-remaining-time:not(.shifted)', self).addClass('shifted');
                if (videoTxt) {
                    $('.vjs-control-bar', self).append(videoTxt);
                }
                videoTabsVideosSetup(self);
                $(self).addClass('is--ready');
            });
        });
    });
    if ($('html').hasClass('is--mob')) {
        var mobPopupVideos = $('.c-video-wrap[data-mob-popup]');
        mobPopupVideos.addClass('off--playsinline');
        mobPopupVideos.click(function (e) {
            e.preventDefault();
            var target = $(this).attr('data-mob-popup');
            openPopup(target);
        });
    }
}

function initPopup() {
    $('.js-popup-link').click(function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        openPopup(target);
    });
    $('.js-close-popup').click(function (e) {
        e.preventDefault();
        closePopup();
    });
}

function openPopup(target) {
    if ($(target).get(0)) {
        $('.c-popup').css({
            'height': '100%',
        });
        var targetPlayer = $(target).find('.js-video > *')[0].player;
        if (targetPlayer) {
            targetPlayer.play();
        }
        setTimeout(function () {
            $('html').addClass('popup-open');
            $(target).css({
                'height': '',
            });
            $(target).addClass('is--active');
        }, 100);
    }
}

function closePopup() {
    var targetPlayer = $('.c-popup .popup.is--active').find('.js-video > *')[0].player;
    if (targetPlayer) {
        targetPlayer.pause();
    }
    $('html').removeClass('popup-open');
    $('.c-popup .popup.is--active').removeClass('is--active');
    setTimeout(function () {
        $('.c-popup .popup').css({
            'height': '0',
        });
        setTimeout(function () {
            $('.c-popup').css({
                'height': '0',
            });
        }, 100);
    }, 400);
}

function initVideoTabs() {
    $('.js-video-tab-link').click(function (e) {
        e.preventDefault();
        videoTabLinkTrigger(this, true);
        if (winWidth < 992) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $($(this).attr('href')).closest('.js-video-tabs').offset().top - $('.header-wrapper').outerHeight()
            }, 500);
        }
    });
}

function videoTabsVideosSetup(target) {
    if ($(target).closest('.js-video-tabs')) {
        var thisId = $(target).closest('.video-tab').attr('id');

        // Set First Item on Display Only.
        if ($(target).closest('.video-tab').is(':first-child')) {
            videoTabLinkTrigger($(`.video-thumb[href="#${thisId}"]`)[0], false);
        }

        // Load Thumb Poster
        var targetPlayer = $(target).find('> *')[0].player;
        var thisPoster = targetPlayer.poster();
        $(`.video-thumb[href="#${thisId}"] .thumb-img`).css({
            'background-image': `url(${thisPoster})`
        });
    }
}

function videoTabLinkTrigger(link, playVideo) {
    var target = $(link).attr('href');
    $(link).closest('.js-video-links-wrap').find('.js-video-tab-link').removeClass('is--active');
    $(link).addClass('is--active');
    openVideoTab(target, playVideo);
}

function openVideoTab(target, playVideo) {
    if ($(target).get(0)) {
        var thisParent = $(target).closest('.js-video-tabs');
        thisParent.find('.video-tab.is--active').removeClass('is--active');
        $(target).addClass('is--active');
        thisParent.find('.video-tab').css({
            'height': 0
        });
        $(target).css({
            'height': '100%',
        });

        // Play & Pause Video
        thisParent.find('.js-video > *').each(function () {
            this.player.pause();
        });
        if (playVideo) {
            var targetPlayer = $(target).find('.js-video > *')[0].player;
            if (targetPlayer) {
                targetPlayer.play();
            }
        }
    }
}

function initTabs() {
    $('.js-tab-link').click(function (e) {
        e.preventDefault();
        tabOpen(this);
    });

    // Open First Tab
    var tabNames = [];
    $('.js-tab-link').each(function () {
        var thisTabName = $(this).attr('data-tab-name');
        tabNames.indexOf(thisTabName) === -1 && tabNames.push(thisTabName);
    });
    for (var i = 0; i < tabNames.length; i++) {
        $(`.js-tab-link[data-tab-name="${tabNames[i]}"]`).eq(0).trigger('click');
    }
}

function tabOpen(link) {
    var tabName = $(link).attr('data-tab-name');
    var target = $(link).attr('href');
    var tabLinks = $(`.js-tab-link[data-tab-name="${tabName}"]`);
    var tabContent = $(`.js-tab-content[data-tab-name="${tabName}"]`);

    tabLinks.removeClass('is--active');
    tabContent.removeClass('is--active');

    tabContent.css('height', '0');

    $(link).addClass('is--active');
    $(target).addClass('is--active');

    $(target).css('height', '');
}


/* ============================== */
/* START - Banner Paralax */

function scrollSecInit() {
    $('[data-scroll-sec]').each(function (i) {
        var thisSec = new scrollSec(this);
        thisSec.init();
        thisSec.updateScrollPos();
    });
}

function scrollSec(target) {
    var self = this;
    this.target = target;
    this.totalSec = $(this.target).attr('data-scroll-sec');
    // this.playVideo = true;

    this.init = function () {
        window.addEventListener('scroll', function () {
            self.updateScrollPos();
        });
    }

    this.updateScrollPos = function () {
        var bodyScrollVal = $('html')[0].scrollTop;
        var totalHeight = $(self.target).height();
        var perSecHeight = totalHeight / self.totalSec;
        var translateTo = 0;
        for (x = 1; x < self.totalSec; x++) {
            var nexSecLim = (perSecHeight * x) - (perSecHeight / 2) + self.target.offsetTop;
            if (bodyScrollVal > nexSecLim) {
                translateTo = x;
                $(self.target).addClass('sec-on--' + x);
            } else {
                $(self.target).removeClass('sec-on--' + x);
            }
        }
        $(self.target).find('.banner-items-wrap').css({
            'transform': `translateX(-${translateTo}00vw)`
        });
        $(self.target).find('.banner-item').removeClass('is--active');
        $(self.target).find('.banner-item').eq(translateTo).addClass('is--active');
    }
}

/* END - Banner Paralax */
/* ============================== */

function initTabCategory() {
    $('body').on('click', '[data-tabit]', function (e) {
        var $this = $(this);
        $this.parents('.tabs-nav').find('li').removeClass('is-active');
        $this.addClass('is-active');
        //$this.siblings().removeClass('is-active');
        var target = $this.data('tabit');
        $('.' + target).siblings('[class^="box-"]').removeClass('showfirst').hide();
        $('.' + target).fadeIn().addClass('showfirst');
    });
}

function acordian() {
    $('body').on('click', '.accordion-box.is-active .js-acordBtn', function () {
        var $this = $(this);
        $this.parents('.accordion-box').removeClass('is-active');
        $this.parents('.accordion-box').find('.accordian-content').slideUp();
    }).on('click', '.accordion-box:not(.is-active) .js-acordBtn', function () {
        var $this = $(this);
        $this.parents('.accordion-box').addClass('is-active');
        $this.parents('.accordion-box').find('.accordian-content').slideDown();
    });
}

function initIsotop(target) {
    var $target = $(target);
    if ($target.length > 0) {
        $target.each(function (i, e) {
            var self = $(this);
            var isotop = self.find('.sec-sortItem').isotope({
                // options
                itemSelector: '.sortItem',
                layoutMode: 'fitRows',
            });

            self.find('.js-filtersBtn').on('click', 'button', function () {
                var filterValue = $(this).attr('data-filter');
                isotop.isotope({
                    filter: filterValue
                });
            });

            self.find('.js-selectsort').on('change', function () {
                var filterValue = this.value;
                isotop.isotope({
                    filter: filterValue
                });
            });
        });
    }

    $('.js-buttonState').each(function (i, buttonGroup) {
        var $buttonGroup = $(buttonGroup);
        $buttonGroup.on('click', 'button', function () {
            $buttonGroup.find('.is-checked').removeClass('is-checked');
            $(this).addClass('is-checked');
        });
    });
}

function createTags() {
    $('.js-tags input').on('keyup', function (e) {
        if (e.keyCode == 13) {
            var txt = this.value.replace(/[^a-zA-Z0-9\+\-\.\#]/g, '');
            var tagappend = $(this).parent('.js-tags');
            if (txt) tagappend.after('<span class="tag">' + txt + '<i class="removeTagBtn">X</i></span>');
            this.value = "";
            this.focus();
        }
        if (this.value !== '') $(this).parent('.js-tags').find('.js-clearSearch').fadeIn();
        if (this.value == '') $(this).parent('.js-tags').find('.js-clearSearch').fadeOut();
    });
    $('.createTags').on('click', '.removeTagBtn', function () {
        $(this).parent('.tag').remove();
    });
    $('.createTags').on('click', '.js-clearSearch', function () {
        $(this).parent('.tag-feild').find('input').val('');
        $(this).fadeOut();
    });
}

function btnReadMore() {
    $('body').on('click', '.js-readmore:not(.is--active)', function () {
        var self = $(this);
        self.addClass('is--active');
        self.children('span').text('Hide Text');
        self.parent().find('.js-hidepara').slideDown();
    }).on('click', '.js-readmore.is--active', function () {
        var self = $(this);
        self.removeClass('is--active');
        self.children('span').text('Read More');
        self.parent().find('.js-hidepara').slideUp();
    });
}

function elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        (top + height) <= (window.pageYOffset + window.innerHeight) &&
        (left + width) <= (window.pageXOffset + window.innerWidth)
    );
}

function elementInViewport2(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
}

function counter() {
    $('.js-counter').each(function (i, ele) {
        var $this = $(ele);
        if (elementInViewport(ele) && !$this.hasClass('has--complete')) {
            $this.prop('Counter', 0).animate({
                Counter: $this.data('value')
            }, {
                duration: 4000,
                easing: 'swing',
                step: function (now) {
                    $this.text(Math.ceil(now));
                }
            });
            $this.addClass('has--complete');
        }
    });
}

/* ============================== */
/* START - Text Slider 2 Sider */

function getWidthVal(target, resize) {
    var $this = $(target);
    $this.each(function (i, e) {
        var elem = $(e),
            getText = elem.attr('data-textToMove');
        textSlider = '<span>' + getText + '</span><span>' + getText + '</span><span>' + getText + '</span> ',
            indexVal = elem.length + 1;

        if (!resize) {
            elem.append(textSlider);
        }

        var getWidth = elem.find('span').width();
        elem.attr('data-width', getWidth);
        destroyCalcIncDec(i);
        calcIncDec(elem, i);
    })
}

var myInterval = [];

function calcIncDec(element, index) {
    var $this = element,
        getSpeed = $this.data('speed'),
        currentValue = 0;
    $this.css('transform', 'translateX(' + currentValue + 'px)');

    myInterval[index] = setInterval(function () {
        if ($this.hasClass('is--animLeftToRight')) {
            if (valueUp == true && currentValue > ('-' + $this.attr('data-width'))) {
                currentValue += subtractValue

                if (currentValue == $this.attr('data-width')) {
                    valueUp = false;
                }
            } else {
                currentValue = 0;

                if (currentValue == 0) {
                    valueUp = true;
                }
            }
        }

        if ($this.hasClass('is--animRightToLeft')) {
            if (valueUp == true && currentValue < $this.attr('data-width')) {
                currentValue += addValue

                if (currentValue == $this.attr('data-width')) {
                    valueUp = false;
                }
            } else {
                currentValue = 0;
                if (currentValue == 0) {
                    valueUp = true;
                }
            }
        }

        $this.css('transform', 'translateX(' + currentValue + 'px)');
    }, getSpeed);
}

function destroyCalcIncDec(i) {
    clearInterval(myInterval[i]);
}

window.onscroll = function (e) {
    var st = $(window).scrollTop();
    userHasScrolled = true;

    if (userHasScrolled) {
        userHasScrolled = false;

        if (st > lastScrollTop) {
            // downscroll code
            subtractValue -= 3;
            if (isRTL) {
                $('.js-rail_track').addClass('is--animRightToLeft').removeClass('is--animLeftToRight');
            } 
            else {
                $('.js-rail_track').addClass('is--animLeftToRight').removeClass('is--animRightToLeft');
            }
        } else {
            // upscroll code
            addValue += 3;
            //$('.js-rail_track').addClass('is--animRightToLeft').removeClass('is--animLeftToRight');
        }
        lastScrollTop = st;
    }
    setTimeout(function () {
        addValue = 1;
        subtractValue = -1;
    }, 10)
}

/* END - Text Slider 2 Sider */
/* ============================== */

$(function () {
    if (winWidth > 767) {
        var topspace = $('.header-wrapper').outerHeight() + 50;
        var calcendHeight = $('.sec-subscribe').outerHeight() + $('.footer').outerHeight() + 50;
    } else {
        var topspace = $('.header-wrapper').outerHeight();
        var calcendHeight = $('.sec-subscribe').outerHeight() + $('.footer').outerHeight() + 50;
    }
    $(".js-sticky-sidebar").sticky({
        topSpacing: topspace,
        zIndex: 0,
        bottomSpacing: calcendHeight,
    });
});

$(document).ready(function () {

});

if ($('.c-sec-map').length > 0) {
    function initMapLogic(lat, lng, zoom) {
        mainMap = new google.maps.Map(document.getElementById('mena-map'), {
            zoom: zoom,
            center: {
                lat: lat,
                lng: lng
            },
            disableDefaultUI: true,
            styles: [{
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{
                    color: '#b3d9fb'
                }]
            }]
        });
        for (var i = markers.length - 1; i >= 0; i--) {
            markers[i].map = mainMap;
            markers[i].init();
        }
    }
    // Custom Marker Constructor
    var markersInoWin = [];
    var markersLength = 0;

    function marker(map, lat, lng, iconSrc, imgSrc, title) {
        var self = this;
        this.map = map;
        this.lat = lat;
        this.lng = lng;
        if (winWidth < 768) {
            var markerSize = 40;
        } else {
            var markerSize = 60;
        }
        this.iconSrc = {
            url: iconSrc,
            scaledSize: new google.maps.Size(markerSize, markerSize)
        }
        this.init = function () {
            // Assign Marker
            this.marker = new google.maps.Marker({
                position: {
                    lat: this.lat,
                    lng: this.lng
                },
                map: this.map,
                icon: this.iconSrc
            });
        };
    }

}
$(".c-detail-content").find('table').wrap("<div class='table-responsive'></div>");

// $('.c-megaMenu ul li > a').on('click', function(e) {
//     e.preventDefault();
//     if ($(e.target).hasClass('js-mega-menu-anchor')) {
//         megaMenu(e.target, 'open')
//     } else {
//         megaMenu(e.target, 'close');
//     }
// });

function megaMenu(target, action) {
    var $this = $(target);
    var menuTarget = $this.data('target');
    if (action == 'open') {
        $('.js-mega-menu[data-menu-id='+menuTarget+']').fadeIn();
    } else {
        $('.js-mega-menu').fadeOut();
    }
}

$('body').on('click', function(e) {
    if (!$(e.target).hasClass('js-mega-menu-anchor')) {
        megaMenu(e.target, 'close');
    }
})

function menuhover() {
    $('body').on("mouseover", '.js-hoverable', function (e) {
        var $this = $(this);
        var o = $this.parent().data("onhover");
        if(o){
            $this.parent().addClass("is--active").siblings().removeClass('is--active');
            $("body").find('.js-hovershow').removeClass("open-menu");
            $("body").find(".js-hovershow." + o).addClass("open-menu");
        } else {
            $(".js-hoverable").removeClass("is--active");
            $("body").find(".js-hovershow").removeClass("open-menu");
        }
    });
}

$('.js-sub-menu-anchor, [data-menu-id] > *').hover(function(){
    menuMouseHoverAdjustmentt();
});
$('.js-sub-menu-anchor, [data-menu-id] > *').mouseout(function(){
    setTimeout(function(){
        menuMouseHoverAdjustmentt();
    }, 500);
});

function menuMouseHoverAdjustmentt() {
    $('.js-sub-menu-anchor').each(function(){
        var thisId = $(this).attr('data-target');
        var thisSubMenu = $('[data-menu-id="'+thisId+'"]');
        var thisSubMenuChild = thisSubMenu.find(' > *');

        if($(this).is(":hover") || $(thisSubMenuChild).is(':hover')){
            $(this).addClass('active');
            thisSubMenu.stop().fadeIn('fast');
        }else{
            $(this).removeClass('active');
            thisSubMenu.stop().fadeOut('fast');
        }
    });
}

// CHAT FLOW
var isTouchScreen = false;
if('ontouchstart' in window || navigator.maxTouchPoints) {
    $('html').addClass('is--touch-screen');
    isTouchScreen = true;
}

$('.pre-chat-btn').addClass('is--open');

$('.js-flow-selector').on('change', function(){
    if($(this).prop('checked')){
        var targetBlock = $(this).attr('data-target-block');
        var hideBlock = $(this).attr('data-hide-block');
        if(hideBlock) {
            $(hideBlock).fadeOut('fast', function(){
                $(targetBlock).fadeIn('fast');
            });
            $('.pre-chat-section .btn-back').css('display', 'block');
        }else{
            $(targetBlock).fadeIn('fast');
        }

        if(targetBlock == '#chat-option-no'){
            closeCustomChatBox(6000);
        }

        if($(this).attr('data-show-chat') == 'yes') {
            var allPText = '';
            $('p', targetBlock).each(function(){
                allPText += $(this).html();
            });
            closeCustomChatBox(allPText.split(' ').length * 475, true);
        }
    }
});

$('.js-back-chat').click(function(e){
    e.preventDefault();
    $('.pre-chat-section input').each(function(){
        this.checked = false;
    });
    if($('#chat-option-1').is(":visible")){
        $(this).hide();
        $('#chat-option-1').stop().fadeOut('fast', function(){
            $('#chat-option-0').stop().fadeIn();
        });
    }

    $('#chat-option-1-a, #chat-option-1-b, #chat-option-1-c, #chat-option-1-d').each(function(){
        if($(this).is(":visible")){
            $(this).stop().fadeOut('fast', function(){
                $('#chat-option-1').stop().fadeIn();
            });
        }
    });
});

// $('.js-close-chatbox').on('change', function(){
//     console.log('changed');
//     if($(this).prop('checked')){
//         closeCustomChatBox(0, true);
//     }
// });

$('.js-min-chatbox').click(function(e) {
    e.preventDefault();
    $('.pre-chat-section').stop().fadeOut('fast', function(){
        $('.pre-chat-btn').addClass('is--open');
        resetChatBox();
    });
});

$('.js-max-chatbox').click(function(e) {
    e.preventDefault();
    $('.pre-chat-btn').removeClass('is--open');
    setTimeout(function(){
        $('.pre-chat-section').css('opacity', '');
        $('.pre-chat-section').stop().fadeIn('fast');
    }, 350);
});

var closeCustomChatBoxTimeout;
function closeCustomChatBox(delayAmount, showChatbox) {
    clearTimeout(closeCustomChatBoxTimeout);
    if(delayAmount > 0) {
        $('.pre-chat-section .loader').animate({width: '100%'}, delayAmount);
    }
    if(showChatbox) {
        $('.pre-chat-section').addClass('freez-min');
    }
    closeCustomChatBoxTimeout = setTimeout(function(){
        if(showChatbox) {
            $('html').addClass('show-chatbox');
            $(`iframe[data-product='web_widget'] + div > iframe`).eq(0).contents().find('button').click(); 
            $('.pre-chat-section').stop().fadeOut('fast');
        }else{
            $('.js-min-chatbox').trigger('click');
        }
    }, delayAmount);
}

function resetChatBox() {
    clearTimeout(closeCustomChatBoxTimeout);
    $('#chat-option-no').hide();
    $('.pre-chat-section .loader').stop();
    $('.pre-chat-section .loader').css({width: '0%'});
    $('.pre-chat-section input').each(function(){
        this.checked = false;
    });
}